import { Modal } from 'antd'
import { sha256 } from 'js-sha256'
import { stringify } from 'querystring'

export function getUrlParamProps(props, name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') //构造一个含有目标参数的正则表达式对象
  var r = props.location.search.substr(1).match(reg) //匹配目标参数
  if (r != null) return decodeURI(r[2])
  return null //返回参数值
}

export function getUrlParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg) //匹配目标参数
  if (r != null) return decodeURI(r[2])
  return null //返回参数值
}

export function regEmail(value) {
  var reg = new RegExp(
    '^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$'
  ) //正则表达式
  if (value === '') {
    //输入不能为空
    return false
  } else if (!reg.test(value)) {
    //正则验证不通过，格式不对
    return false
  } else {
    return true
  }
}

export function switchLan() {
  let storage = window.localStorage;
  if (storage.language === 'zh-CN') {
    storage.language = 'en-US'
    return 'en-US'
  } else {
    storage.language = 'zh-CN'
    return 'zh-CN'
  }
}
